<template>
  <div class="page">
    <div v-if="loading"> <Loading/> </div>
    <main v-if="!loading">
      <v-row justify="center">
        <v-col align="center">
          <img src="@/assets/icon.svg" alt="Wrapp icon" class="logo" height="100"/>
          <form @submit.prevent="forgot">
            <div>
              <v-row>
                <v-col align="left">
                  <v-btn class="btn-reset" href = "/login" style="background-color: red; color: white;">
                    <feather type="chevron-left" size="18"></feather>
                    Back
                  </v-btn>
                </v-col>
              </v-row>
              <br/>
              <validation-observer ref="observer-forgot">
                <validation-provider rules="email" v-slot="{ errors }">
                  <input
                    autocomplete="off"
                    type="email"
                    name="username"
                    id="email"
                    v-model="email"
                    placeholder="Email"
                    :class="(errors[0]) ? 'input-error' : ''"
                  />
                  <span class="input-error-text">{{ errors[0] }}</span>
                </validation-provider>
              </validation-observer>
              <v-row justify="center">
                <v-col align="center">
                  <v-btn class="btn-reset" type="submit" style="background-color: red; color: white;">
                    Reset
                    <feather type="chevron-right" size="18"></feather>
                  </v-btn>
                </v-col>
              </v-row>
              
              
            </div>
          </form>
        </v-col>
      </v-row>
    </main>
    <span class="copyright">© Wrapp {{ new Date().getFullYear() }}</span>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { email, required } from "vee-validate/dist/rules";

extend("email", {
  ...email,
  message: "Invalid email"
});
extend('required', {
  ...required, 
  message: 'This field is required'
});

export default {
  name: "Forgot",
  components: {
    ValidationObserver,
    ValidationProvider,
    Loading
  },
  data() {
    return {
      email: '',
      loading: false
    };
  },
  methods: {
    async forgot() {
      if (await this.$refs["observer-forgot"].validate()) {
        this.loading = true;
        await this.$store.dispatch('auth/forgot', this.email);
        this.$router.push('/login');
      }
    }
  }
};
</script>

<style lang="scss" scoped src="@/scss/auth.scss"></style>
<style lang="scss" scoped>
.errors {
  color: $error-color;
  text-align: center;
}
</style>